import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { EMPLOYEE_API } from "./apiRoutes";

interface UseGetEmployeeActiveListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getEmployeeActiveList = async (data: any) => {
  return await axiosAuth.get(`${EMPLOYEE_API}/employees`, data);
};

const useGetEmployeeActiveList = ({
  data,
  queryParams,
}: UseGetEmployeeActiveListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["employee-active-list"],
    queryFn: () => getEmployeeActiveList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetEmployeeActiveList;
